import { TFunction } from "i18next";
import { isNumber } from "lodash-es";

import { JobRequestListDto } from "@/data/job-requests/types/JobRequest";
import { JobRequestShort } from "@/data/job-requests/types/JobRequestShort";
import { ILegalEntityShort } from "@/data/public-profiles";

import { IJobRequest } from "./types-ensure";

export const getRemotenessText = (remoteness: IJobRequest["remoteness"], t: TFunction) => {
  let remotenessValue = 0;

  if (isNumber(remoteness) && remoteness >= 0 && remoteness <= 100) {
    remotenessValue = remoteness;
  }

  if (remotenessValue === 0) {
    return t("session:JOB_REQUESTS.DETAIL.REMOTENESS.REMOTE_NONE");
  } else if (remotenessValue === 100) {
    return t("session:JOB_REQUESTS.DETAIL.REMOTENESS.REMOTE_FULL");
  } else {
    return t("session:JOB_REQUESTS.DETAIL.REMOTENESS.REMOTE_PARTIAL");
  }
};

interface JobRequestClientInfo {
  name: string;
  logoPublicUrl?: string;
  administratorName?: string;
  administratorLogoPublicUrl?: string;
  administratorVatNumber?: string | null;
  legalEntity?: ILegalEntityShort | null;
}

export const getJobRequestClientInfo = (
  jr: Partial<JobRequestListDto> | Partial<JobRequestShort>,
): JobRequestClientInfo => {
  const promotedNames = [
    jr.legalEntityClient?.name,
    jr.client?.name,
    jr.administratorLegalEntityClient?.name,
    jr.origin?.name,
  ];
  const notPromotedNames = [jr.administratorLegalEntityClient?.name, jr.origin?.name];
  const administratorName = notPromotedNames.filter(n => !!n)[0];
  const name = jr.promoteClient ? promotedNames.filter(n => !!n)[0]! : notPromotedNames.filter(n => !!n)[0]!;

  const promotedLogos = [
    jr.legalEntityClient?.logoPublicUrl,
    jr.client?.logo?.publicUrl,
    jr.administratorLegalEntityClient?.logoPublicUrl,
    jr.origin?.details?.logo,
  ];
  const notPromotedLogos = [jr.administratorLegalEntityClient?.logoPublicUrl, jr.origin?.details?.logo];
  const administratorLogoPublicUrl = notPromotedLogos.filter(n => !!n)[0];
  const logoPublicUrl = jr.promoteClient ? promotedLogos.filter(n => !!n)[0] : notPromotedLogos.filter(n => !!n)[0];

  const administratorVatNumbers = [jr.administratorLegalEntityClient?.vatNumber, jr.origin?.details?.vatNumber];
  const administratorVatNumber = administratorVatNumbers.filter(n => !!n)[0];

  const legalEntity = jr.promoteClient ? jr.legalEntityClient : jr.administratorLegalEntityClient;

  return {
    name,
    logoPublicUrl: logoPublicUrl ?? undefined,
    administratorName,
    administratorLogoPublicUrl: administratorLogoPublicUrl ?? undefined,
    administratorVatNumber,
    legalEntity,
  };
};
